// Données mockées pour l'application de réservation
export interface Child {
  id: string;
  name: string;
  age: number;
  daysUsed: number;
  maxDays: number;
}

export interface Reservation {
  id: string;
  childId: string;
  childName: string;
  date: string;
  status: 'pending' | 'approved' | 'rejected';
  reason?: string;
}

export interface DayBlock {
  date: string;
  reason: string;
}

export interface Capacity {
  date: string;
  maxCapacity: number;
  currentOccupancy: number;
}

// Enfants inscrits
export const children: Child[] = [
  { id: '1', name: 'Lucas Martin', age: 8, daysUsed: 23, maxDays: 90 },
  { id: '2', name: 'Emma Dubois', age: 6, daysUsed: 45, maxDays: 90 },
  { id: '3', name: 'Thomas Bernard', age: 10, daysUsed: 12, maxDays: 90 },
  { id: '4', name: 'Chloé Petit', age: 7, daysUsed: 67, maxDays: 90 },
  { id: '5', name: 'Noah Lambert', age: 9, daysUsed: 34, maxDays: 90 },
  { id: '6', name: 'Léa Moreau', age: 5, daysUsed: 56, maxDays: 90 },
];

// Réservations
export const reservations: Reservation[] = [
  { id: '101', childId: '1', childName: 'Lucas Martin', date: '2025-04-25', status: 'approved' },
  { id: '102', childId: '2', childName: 'Emma Dubois', date: '2025-04-26', status: 'pending' },
  { id: '103', childId: '3', childName: 'Thomas Bernard', date: '2025-04-27', status: 'rejected', reason: 'Capacité maximale atteinte' },
  { id: '104', childId: '4', childName: 'Chloé Petit', date: '2025-04-28', status: 'approved' },
  { id: '105', childId: '5', childName: 'Noah Lambert', date: '2025-04-29', status: 'pending' },
  { id: '106', childId: '6', childName: 'Léa Moreau', date: '2025-04-30', status: 'approved' },
  { id: '107', childId: '1', childName: 'Lucas Martin', date: '2025-05-02', status: 'pending' },
  { id: '108', childId: '2', childName: 'Emma Dubois', date: '2025-05-03', status: 'approved' },
];

// Jours bloqués
export const blockedDays: DayBlock[] = [
  { date: '2025-05-01', reason: 'Jour férié - Fête du Travail' },
  { date: '2025-05-08', reason: 'Jour férié - Victoire 1945' },
  { date: '2025-05-15', reason: 'Formation du personnel' },
  { date: '2025-05-22', reason: 'Maintenance des locaux' },
];

// Capacité par jour
export const dailyCapacity: Capacity[] = [
  { date: '2025-04-25', maxCapacity: 5, currentOccupancy: 2 },
  { date: '2025-04-26', maxCapacity: 5, currentOccupancy: 3 },
  { date: '2025-04-27', maxCapacity: 5, currentOccupancy: 5 },
  { date: '2025-04-28', maxCapacity: 5, currentOccupancy: 2 },
  { date: '2025-04-29', maxCapacity: 5, currentOccupancy: 3 },
  { date: '2025-04-30', maxCapacity: 5, currentOccupancy: 4 },
  { date: '2025-05-02', maxCapacity: 5, currentOccupancy: 1 },
  { date: '2025-05-03', maxCapacity: 5, currentOccupancy: 2 },
];

export const monthlyStats = [
  { month: 'Janvier', inscriptions: 45 },
  { month: 'Février', inscriptions: 38 },
  { month: 'Mars', inscriptions: 52 },
  { month: 'Avril', inscriptions: 65 },
  { month: 'Mai', inscriptions: 48 },
  { month: 'Juin', inscriptions: 56 },
];

export const weekdayStats = [
  { jour: 'Lundi', taux: 75 },
  { jour: 'Mardi', taux: 85 },
  { jour: 'Mercredi', taux: 95 },
  { jour: 'Jeudi', taux: 65 },
  { jour: 'Vendredi', taux: 70 },
];
